export default class InsufficientCoins extends Error {
  constructor(message) {
    super(message);
    this.name = "InsufficientCoins";
  }
}
